import clsx from 'clsx'
import React, { useRef, useState } from 'react'

import s from './styles.module.scss'

import { Icon } from '../../atoms'
import { useOnClickOutside } from '../../../lib/hooks'

const OptionsMenu = <T extends { _id: string; disabled?: boolean }>({
  options,
  optionTemplate,
  closeMenu,
  containerClassName,
  optionContainerClassName,
  disabled,
  onClickOption,
}: {
  options: T[]
  optionTemplate: (option: T) => React.ReactElement
  closeMenu: () => void
  containerClassName?: string
  optionContainerClassName?: string
  disabled?: boolean
  onClickOption: (option: T) => void
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useOnClickOutside(ref, () => closeMenu())

  return (
    // s.menu
    <div className={containerClassName} ref={ref}>
      {options.map((option) => (
        <div
          className={clsx([
            optionContainerClassName,
            { [s.disable]: option.disabled },
          ])}
          onClick={() => {
            if (!disabled) {
              onClickOption && onClickOption(option)
              closeMenu && closeMenu()
            }
          }}
          key={option._id}
        >
          {optionTemplate(option)}
        </div>
      ))}
    </div>
  )
}

const DropDown = <T extends { _id: string; disabled?: boolean }>({
  options,
  optionTemplate,
  children,
  containerClassName,
  optionContainerClassName,
  optionsContainerClassName,
  onClickOption,
}: {
  options: T[]
  optionTemplate: (option: T) => React.ReactElement
  children: React.ReactNode
  containerClassName?: string
  optionContainerClassName?: string
  optionsContainerClassName?: string
  onClickOption: (option: T) => void
}) => {
  const [showDropDown, setShowDropDown] = useState<boolean>(false)

  return (
    <div className={containerClassName}>
      <div
        onClick={() => {
          if (!showDropDown) {
            setShowDropDown(true)
          }
        }}
      >
        {children}
        {showDropDown ? (
          <Icon name='arrow-down' size={12} />
        ) : (
          <Icon name='arrow-up' size={12} />
        )}
      </div>
      {showDropDown && (
        <OptionsMenu<T>
          containerClassName={optionsContainerClassName}
          options={options}
          optionTemplate={optionTemplate}
          closeMenu={() => setShowDropDown(false)}
          onClickOption={onClickOption}
          optionContainerClassName={optionContainerClassName}
        />
      )}
    </div>
  )
}

export default DropDown
